import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { Col, Row, Container } from "reactstrap";

const StatisticsShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);

	const [singleStatistic, setSingleStatistic] = useState({
		count: "",
		sectionTitle: { ar: "", en: "" },
		sectionSubTitle: { ar: "", en: "" },
	});

	const {
		params: { statsticSlug },
	} = match;
	const dispatch = useDispatch();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: " تعديل  الاحصائية  ",
				breadcrumb: " الاحصائيات ",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(
				`${process.env.REACT_APP_API_URL}pages/statistics/sections/${statsticSlug}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(response => {
				setSingleStatistic({ ...response.data.data.section });
			});
	};

	useEffect(() => {
		onStart();
	}, []);

	const handleSubmit = e => {
		e.preventDefault();
		if (!singleStatistic.count) {
			toast.error("برجاء كتابة العدد");
			return;
		} else if (!singleStatistic.sectionTitle.ar) {
			toast.error("برجاء كتابة العنوان  باللغة العربية");
			return;
		} else if (!singleStatistic.sectionTitle.en) {
			toast.error("برجاء كتابة العنوان  باللغة الإنجليزية");
			return;
		}

		axios
			.put(
				`${process.env.REACT_APP_API_URL}pages/statistics/sections/${statsticSlug}`,
				{
					section: singleStatistic,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(
				_ =>
					toast.success("تم تعديل البيانات بنجاح") &&
					history.push("/statistics/index")
			)
			.catch(_ => toast.error("حدث خطا !"));
	};

	return (
		<section>
			<Container>
				<div className="card">
					<div className="card-body">
						<Row style={{ marginTop: "2rem" }}>
							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="count"> العدد </label>

									<input
										type="text"
										id="count"
										name="count"
										value={singleStatistic?.count ?? ""}
										onChange={e => {
											setSingleStatistic({
												...singleStatistic,
												count: e.target.value,
											});
										}}
									/>
								</div>
							</Col>
						</Row>
						<Row style={{ marginTop: "2rem" }}>
							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="titleAr">العنوان باللغة العربية </label>

									<input
										type="text"
										id="titleAr"
										name="titleAr"
										value={singleStatistic?.sectionTitle?.ar ?? ""}
										onChange={e => {
											setSingleStatistic({
												...singleStatistic,
												sectionTitle: {
													...singleStatistic.sectionTitle,
													ar: e.target.value,
												},
											});
										}}
									/>
								</div>
							</Col>

							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="sectionTitleEn">
										العنوان باللغة الانجليزية
									</label>

									<input
										type="text"
										id="sectionTitleEn"
										name="sectionTitleEn"
										value={singleStatistic?.sectionTitle?.en ?? ""}
										onChange={e => {
											setSingleStatistic({
												...singleStatistic,
												sectionTitle: {
													...singleStatistic.sectionTitle,
													en: e.target.value,
												},
											});
										}}
									/>
								</div>
							</Col>
						</Row>
						{/* <Row style={{ marginTop: "2rem" }}>
							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="sectionSubTitleAr">
										العنوان الفرعى باللغة العربية{" "}
									</label>

									<input
										type="text"
										id="sectionSubTitleAr"
										name="sectionSubTitleAr"
										value={singleStatistic?.sectionSubTitle?.ar ?? ""}
										onChange={e => {
											setSingleStatistic({
												...singleStatistic,
												sectionSubTitle: {
													...singleStatistic.sectionSubTitle,
													ar: e.target.value,
												},
											});
										}}
									/>
								</div>
							</Col>

							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="subTitleEn">
										العنوان الفرعى باللغة الانجليزية
									</label>

									<input
										type="text"
										id="subTitleEn"
										name="subTitleEn"
										value={singleStatistic?.sectionSubTitle?.en ?? ""}
										onChange={e => {
											setSingleStatistic({
												...singleStatistic,
												sectionSubTitle: {
													...singleStatistic.sectionSubTitle,
													en: e.target.value,
												},
											});
										}}
									/>
								</div>
							</Col>
						</Row> */}

						<Row>
							<Col>
								<div className="form-item mt-3">
									<button
										className="bt bt-success btn-block"
										onClick={handleSubmit}
									>
										ارسال
									</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default StatisticsShow;
